"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignmentReducer = exports.useAssignmentV2Reducer = exports.initialAssignmentState = void 0;
const react_1 = require("react");
const initialAssignmentValues = {
    positions: []
};
exports.initialAssignmentState = {
    data: initialAssignmentValues,
    errors: null,
    isUpdating: false,
    isCreating: false,
    status: null,
    isFetching: true,
    isDeleting: false,
    isLoading: false,
    creatingWorkType: false,
    isCreatingCorrection: false
};
const useAssignmentV2Reducer = () => {
    return (0, react_1.useReducer)(exports.assignmentReducer, exports.initialAssignmentState);
};
exports.useAssignmentV2Reducer = useAssignmentV2Reducer;
const assignmentReducer = (state, action) => {
    switch (action.type) {
        case 'SEND_EMPLOYEE_ASSIGNMENTS_REQUEST':
            return {
                ...state,
                errors: null,
                isFetching: true,
                isLoading: true
            };
        case 'DONE_EMPLOYEE_ASSIGNMENTS_REQUEST':
            return {
                ...state,
                data: {
                    ...state.data,
                    positions: action.payload.data || state.data.positions
                },
                errors: action.payload.errors,
                isFetching: false,
                isLoading: false
            };
        case 'SEND_EMPLOYEE_ASSIGNMENT_UPDATE':
            return {
                ...state,
                isCreating: true
            };
        case 'DONE_EMPLOYEE_ASSIGNMENT_UPDATE':
            return {
                ...state,
                data: {
                    positions: state.data.positions && state.data.positions.map(el => {
                        return el.assignId === action.payload.data?.assignId ? action.payload.data : el;
                    })
                },
                isCreating: false,
                errors: action.payload.errors
            };
        case 'SEND_EMPLOYEE_ASSIGNMENT_CREATE':
            return {
                ...state,
                isUpdating: true
            };
        case 'DONE_EMPLOYEE_ASSIGNMENT_CREATE':
            return {
                ...state,
                data: {
                    positions: state.data.positions && action.payload.data ? [action.payload.data, ...state.data.positions] : state.data.positions
                },
                isUpdating: false,
                errors: action.payload.errors
            };
        case 'SEND_CREATE_WORK_TYPE_REQUEST':
            return {
                ...state,
                creatingWorkType: true
            };
        case 'DONE_CREATE_WORK_TYPE_REQUEST':
            return {
                ...state,
                creatingWorkType: false
            };
        case 'SEND_ASSIGNMENT_DELETE_REQUEST':
            return {
                ...state,
                isDeleting: true
            };
        case 'DONE_ASSIGNMENT_DELETE_REQUEST':
            return {
                ...state,
                errors: action.payload,
                isDeleting: false
            };
    }
};
exports.assignmentReducer = assignmentReducer;
